import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { StoreState } from '@/store';
import { State } from './duck/reducer';

@Component({
  selector: 'app-modal-error',
  templateUrl: './modal-error.component.html',
  styleUrls: ['./modal-error.component.css'],
})
export class ModalErrorComponent {

  state: State = {
    title: '',
    text: '',
    visible: false,
  }

  constructor(
    private store: Store<StoreState>,
  ) {
    const storeSlice$ = this.store.select('modalError');
    storeSlice$.subscribe({
      next: (newState) => {
        this.state = newState;
      },
    });
  }
}
